import React, { useState } from "react";
import OverviewInfo from "./OverviewInfo";
import OverviewContacts from "./OverviewContacts";
import OverviewDetails from "./OverviewDetails";
import OverviewAwardee from "./OverviewAwardee";
import RfqOverview from "../RfqOverview";
import EditRfqNew from "views/Rfqs/EditRfqNew";
import RFQSavings from "./RFQSavings";
import CustomTimeline from "./CustomTimeline";
import { updateRFQDisplayRanks } from "actions/rfqActions";
import { useDispatch, useSelector } from "react-redux";

const Overview = ({ data, hasAwarded, handleOpenEditAwardees, openEditRfq, setOpenEditRfq, setActiveTab }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth?.user);
  const [rankingMode, setRankingMode] = useState(data?.displayRanks);
  const [showDialog, setShowDialog] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false); // Loading state
  const [pendingValue, setPendingValue] = useState(null); // Store pending toggle value

  const handleToggle = () => {
    setPendingValue(!rankingMode); // Store the new value
    setShowDialog(true); // Show dialog for confirmation
  };

  const updateDisplayRanks = async (newRankingMode) => {
    setIsUpdating(true);
    try {
      await dispatch(updateRFQDisplayRanks({
        rfqId: data.rfqId,
        displayRanks: newRankingMode,
        actionBy: {
          userId: user?.userId,
          name: user?.name,
          email: user?.email,
        },
      }));
      setRankingMode(newRankingMode);
    } catch (error) {
      console.error("Failed to update display ranks:", error);
    } finally {
      setIsUpdating(false);
    }
  };

  const handleConfirm = () => {
    if (pendingValue !== null) {
      updateDisplayRanks(pendingValue); // Apply the stored value
    }
    setShowDialog(false);
    setPendingValue(null); // Reset pending value
  };

  const handleCancel = () => {
    setShowDialog(false);
    setPendingValue(null); // Reset pending value
  };

  const creationDate = data?.createdAt || data?.createdDate;
  const statusLogs = data?.statusLogs || [];
  const hasOpenStatusLog = statusLogs.some(
    (item) => item?.changedStatusTo?.toUpperCase() === "OPEN"
  );
  const timelineLogs =
    creationDate && !hasOpenStatusLog
      ? [
        {
          date: creationDate,
          changedStatusTo: "OPEN",
          isCreatedLog: true,
        },
        ...statusLogs,
      ]
      : statusLogs;

  return (
    <div className="flex gap-x-6 w-full pb-5" style={{ fontFamily: "goldman_sans" }}>
      <div className="flex flex-col w-3/4 gap-y-3">
        <div className="col-span-3 row-span-2 bg-white rounded-sm shadow-md flex items-center justify-center p-4">
          <OverviewInfo data={data} />
        </div>
        {/* <div className="col-span-3 row-span-2 bg-white rounded-lg shadow-md flex items-center justify-center p-8">
          <OverviewDetails
            description={data?.description}
            selectedFilesBase={data?.selectedFilesBase}
          />
        </div> */}
        <div className="rounded-sm">
          <RfqOverview data={data} />
        </div>
      </div>
      <div className="flex flex-col w-1/4 gap-y-3">
        {hasAwarded && (
          <div className="bg-white rounded-sm shadow-md flex items-center justify-center px-4 py-3 max-h-[calc(100vh-280px)] overflow-auto">
            <OverviewAwardee
              awardeeDetails={data?.suppliers.filter(
                (supplier) => supplier?.closingDetails?.length >= 1
              )}
              data={data}
              handleOpenEditAwardees={handleOpenEditAwardees}
            />
          </div>
        )}

        {/* Ranking Mode Selection */}
        {data?.status !== "CLOSED" &&
          <>
            <div className="col-span-2 pl-4">
              {/* <div className="flex items-center space-x-2">
                <p className="text-sm font-semibold">Show Rank to Vendors :</p>
                <div className="flex items-center justify-between">
                  <button
                    className={`relative w-8 h-4 mb-1 rounded-full p-0.5 transition duration-300 ${rankingMode ? "bg-blue-600" : "bg-gray-300"
                      } ${isUpdating ? "opacity-50 cursor-not-allowed" : ""}`}
                    onClick={!isUpdating ? handleToggle : undefined}
                    disabled={isUpdating} // Disable button during API call
                  >
                    <div
                      className={`w-3 h-3 bg-white rounded-full shadow-md transform transition ${rankingMode ? "translate-x-4" : "translate-x-0"
                        }`}
                    />
                  </button>
                </div>
              </div> */}

              {/* Dialog Box */}
              {showDialog && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                  <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                    <p className="mb-4 font-medium">
                      {pendingValue
                        ? "This will show ranks to individual vendors."
                        : "This will hide ranks from vendors."}
                    </p>
                    <div className="flex justify-end space-x-4">
                      <button className="px-4 py-2 bg-gray-300 rounded" onClick={handleCancel}>
                        No
                      </button>
                      <button className="px-4 py-2 bg-blue-600 text-white rounded" onClick={handleConfirm}>
                        Yes
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        }

        <div className="  flex items-center justify-center px-4 py-2">
          <OverviewContacts
            newCcEmails={data?.newCcEmails}
            creator={data?.requesterName}
          />
        </div>

        {(data?.status === "CLOSED" || data?.status === "PENDING APPROVAL") && <div className="  flex items-center justify-center px-4 pt-3">
          <RFQSavings
            rfqData={data}
          />
        </div>}

        {/* {(data?.status === "CLOSED" || data?.status === "PENDING APPROVAL" || data?.status === "REWORK") && ( */}
          <div className="bg-white rounded-sm shadow-md px-4 py-3 max-h-[300px] overflow-auto">
            
            <div className="mb-3 flex items-center justify-between gap-3">
              <p className="text-sm font-semibold">RFQ Timeline</p>
              <button
                type="button"
                onClick={() => setActiveTab("RFQ Timeline")}
                className="shrink-0 text-[11px] font-medium text-blue-700 hover:underline"
              >
                View full timeline
              </button>
            </div>

            <div className="flex flex-col">
              {timelineLogs.map((item, index, arr) => {
                const date = item?.date?.$date || item?.date;

                return (
                  <div key={index} className="flex items-start gap-2">

                    {/* Time */}
                    <div className="text-[11px] text-gray-500 text-start whitespace-nowrap">
                      {new Date(date).toLocaleDateString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                      <br />
                      {new Date(date).toLocaleTimeString("en-IN", {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </div>

                    {/* Line + Dot */}
                    <div className="relative flex flex-col items-center self-stretch w-[20px]">
                      
                      {/* Line */}
                      {index !== arr.length - 1 && (
                        <div className="absolute top-2 bottom-0 left-1/2 w-[1px] -translate-x-1/2 bg-gray-300"></div>
                      )}

                      {/* Dot */}
                      <div className="relative z-10 w-2 h-2 bg-gray-400 rounded-full"></div>
                    </div>

                    {/* Content */}
                    <div className="flex-1 text-xs pb-4">
                      <p className="text-gray-700 font-medium">
                        {item.changedStatusTo}
                      </p>
                      {item?.isCreatedLog ? (
                        <p className="text-gray-400">RFQ created</p>
                      ) : item?.changedStatusFrom ? (
                        <p className="text-gray-400">
                          from {item.changedStatusFrom}
                        </p>
                      ) : null}
                    </div>

                  </div>
                );
              })}
            </div>
          </div>
        {/* )} */}

        {(data?.status === "CLOSED" || data?.status === "PENDING APPROVAL" || data?.status === "REWORK") && <div className="  flex items-center justify-start pr-4 pt-1">
          <CustomTimeline
            rfqData={data}
          />
        </div>}
      </div>


      {openEditRfq && <EditRfqNew setOpenEditRfq={setOpenEditRfq} data={data} setActiveTab={setActiveTab} />}

    </div>
  );
};

export default Overview;
